import Accordion from 'entities/Accordion'
import { ScheduleIntervalsSelector } from 'features/ScheduleIntervalsSelector'
import { ScheduleWeek } from 'features/ScheduleWeek'

export const Schedule = () => {
  return (
    <Accordion title='Schedule'>
      <ScheduleIntervalsSelector />
      <ScheduleWeek />
    </Accordion>
  )
}
